module.exports = __webpack_public_path__ + "static/media/house.92def3b5.png";